import { create } from 'zustand';
import type { AuthUser } from '@codedrill/shared';

interface AuthStoreState {
  user: AuthUser | null;
  accessToken: string | null;

  /**
   * Set during login when the server responds with requires2FA: true.
   * Cleared immediately after the 2FA step completes (success or cancel).
   * Never persisted to storage — lives only in memory.
   */
  pendingTwoFAToken: string | null;

  setAuth: (user: AuthUser, accessToken: string) => void;
  updateUser: (user: AuthUser) => void;
  clearAuth: () => void;
  setPendingTwoFA: (token: string) => void;
  clearPendingTwoFA: () => void;
}

const storedToken =
  typeof window !== 'undefined'
    ? (sessionStorage.getItem('access_token') ?? null)
    : null;

export const useAuthStore = create<AuthStoreState>((set) => ({
  user: null,
  accessToken: storedToken,
  pendingTwoFAToken: null,

  setAuth: (user, accessToken) => {
    sessionStorage.setItem('access_token', accessToken);
    localStorage.setItem('had_session', '1');
    set({ user, accessToken, pendingTwoFAToken: null });
  },

  updateUser: (user) => set({ user }),

  clearAuth: () => {
    sessionStorage.removeItem('access_token');
    localStorage.removeItem('had_session');
    set({ user: null, accessToken: null, pendingTwoFAToken: null });
  },

  setPendingTwoFA: (token) => set({ pendingTwoFAToken: token }),

  clearPendingTwoFA: () => set({ pendingTwoFAToken: null }),
}));
